import { render, staticRenderFns } from "./ClienteContactoInfoIndex.vue?vue&type=template&id=13d456b3&scoped=true&"
import script from "./ClienteContactoInfoIndex.vue?vue&type=script&lang=js&"
export * from "./ClienteContactoInfoIndex.vue?vue&type=script&lang=js&"
import style0 from "./ClienteContactoInfoIndex.vue?vue&type=style&index=0&id=13d456b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d456b3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanelContent})
